export async function loadSalesHistory({limit, offset, searchQuery, filter }) {
  const response = await fetch(`${process.env.REACT_APP_WP_AJAX_URL}?action=get_applications`, {
    method: "POST",
    body: JSON.stringify({
      limit,
      offset,
      searchQuery,
      filter,
    }),
    headers: {
      "Content-Type": "application/json"
    },
    credentials: "include"
  });

  if (response.ok) {
    const { data, count } = await response.json();
    return { data, count };
  }

  return { data: [], count: 0 };
}

export async function updateApplication(application) {
  const response = await fetch(`${process.env.REACT_APP_WP_AJAX_URL}?action=update_application`, {
    method: "POST",
    body: JSON.stringify(application),
    headers: {
      "Content-Type": "application/json"
    },
    credentials: "include"
  });

  if (response.ok) {
    const body = await response.json();
    if (body && body.error) {
      return Promise.reject({error: body.error});
    }
    return Promise.resolve();
  }

  return Promise.reject();
}

export async function loadAgencyPaymentDetails({ agencyId, agencyNonce }) {
  const response = await fetch(`${process.env.REACT_APP_WP_AJAX_URL}?action=apasi_load_agency_payment_details`, {
    method: "POST",
    body: JSON.stringify({ agencyId, agencyNonce }),
    headers: { "Content-Type": "application/json" },
    credentials: "include"
  });

  if (response.ok) {
    const body = await response.json();
    if (body && body.error) {
      return Promise.reject({error: body.error});
    }
    return { minPrice: body.minPrice, maxPrice: body.maxPrice, paymentPlans: body.paymentPlans, isAgencySpecific: body.isAgencySpecific }
  }

  return Promise.reject();
}

export async function loadApplicationPaymentHistory(applicationId) {
  const response = await fetch(`${process.env.REACT_APP_WP_AJAX_URL}?action=apasi_load_application_payment_history`, {
    method: "POST",
    body: JSON.stringify({ applicationId }),
    headers: { "Content-Type": "application/json" },
    credentials: "include"
  });

  if (response.ok) {
    const body = await response.json();
    if (body && body.error) {
      return Promise.reject({error: body.error});
    }
    return body;
  }

  return Promise.reject();
}

export async function loadApplicationsDetails(appNonce) {
  const response = await fetch(`${process.env.REACT_APP_WP_AJAX_URL}?action=apasi_load_application_details`, {
    method: "POST",
    body: JSON.stringify({ appNonce }),
    headers: { "Content-Type": "application/json" },
    credentials: "include"
  });

  if (response.ok) {
    const body = await response.json();
    if (body && body.error) {
      return Promise.reject({error: body.error});
    }
    return body;
  }

  return Promise.reject();
}

export async function createApplications(applications) {
  const response = await fetch(`${process.env.REACT_APP_WP_AJAX_URL}?action=apasi_membership_registration_new`, {
    method: "POST",
    body: JSON.stringify(applications),
    headers: { "Content-Type": "application/json" },
    credentials: "include"
  });

  if (response.ok) {
    const body = await response.json();
    if (body && body.error) {
      return Promise.reject({error: body.error});
    }
    return body;
  }

  return Promise.reject();
}

export async function purchaseApplication(appNonce, form) {
  const response = await fetch(`${process.env.REACT_APP_WP_AJAX_URL}?action=apasi_membership_payment`, {
    method: "POST",
    body: JSON.stringify({ application_id: appNonce, ...form }),
    headers: { "Content-Type": "application/json" },
    credentials: "include"
  });

  if (response.ok) {
    const body = await response.json();
    if (body && body.error) {
      return Promise.reject({error: body.error});
    }
    return body;
  }

  return Promise.reject();
}

export async function sendApplicationContractOnEmail(applicationId) {
  const response = await fetch(`${process.env.REACT_APP_WP_AJAX_URL}?action=send_application_contract_on_email`, {
    method: "POST",
    body: JSON.stringify({
      id: applicationId
    }),
    headers: { "Content-Type": "application/json" },
    credentials: "include"
  });

  if (response.ok) {
    const body = await response.json();
    if (body && body.error) {
      return Promise.reject({error: body.error});
    }
    return body;
  }

  return Promise.reject();
}

export async function sendMemberCardOnEmail(applicationId) {
  const response = await fetch(`${process.env.REACT_APP_WP_AJAX_URL}?action=send_member_card_on_email`, {
    method: "POST",
    body: JSON.stringify({
      id: applicationId
    }),
    headers: { "Content-Type": "application/json" },
    credentials: "include"
  });

  if (response.ok) {
    const body = await response.json();
    if (body && body.error) {
      return Promise.reject({error: body.error});
    }
    return body;
  }

  return Promise.reject();
}
